import { ComponentIds, HierarchyUtils, } from "@inter-ikea-core/core";
import { ValidationBase } from "@inter-ikea-core/core-toolbox";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { getUprights } from "../utils/sectionsHelpers";
import { generateValidationFail } from "../utils/helpers";
const FAIL_MSG = "Upright can not be moved here";
export default class LimitUprightsToMountingRailConnectionValidation extends ValidationBase {
    constructor() {
        super(...arguments);
        this.id = "LimitUprightsToMountingRailConnectionValidation";
        this.hasComponents = (firstEntity, secondEntity) => firstEntity.hasComponent(COMPONENT_IDS.MOUNTING_RAIL_COMPONENT) &&
            secondEntity.hasComponent(COMPONENT_IDS.UPRIGHT_COMPONENT);
        this.isMountingRailToUprightConnection = (guest, host) => {
            if (this.hasComponents(guest, host))
                return { mountingRail: guest, upright: host };
            if (this.hasComponents(host, guest))
                return { mountingRail: host, upright: guest };
            return false;
        };
    }
    validateCurrentState(_entity) {
        return null;
    }
    validateSnap({ guest, host }) {
        const connectionEntities = this.isMountingRailToUprightConnection(guest, host);
        if (!connectionEntities)
            return null;
        const { mountingRail, upright } = connectionEntities;
        if (!mountingRail.hasComponent(ComponentIds.HOST_CONNECTIONS_COMPONENT_ID))
            return null;
        const { leftUpright, rightUpright } = getUprights(mountingRail);
        if (leftUpright && rightUpright && rightUpright.id !== upright.id)
            return generateValidationFail(guest, FAIL_MSG);
        const uprightParent = HierarchyUtils.parent(upright);
        if (uprightParent &&
            uprightParent.id !== mountingRail.id &&
            host.hasComponent(COMPONENT_IDS.MOUNTING_RAIL_COMPONENT))
            return generateValidationFail(guest, FAIL_MSG);
        return null;
    }
}
